import "./pt-nuscale-piping-pipe-secondary.css"
import FLOW_NOFLOW from "../../mixins/FLOW_NOFLOW"

export default {
    selector: "g.pt-piping-pipe-secondary",
    mixins: [FLOW_NOFLOW]    
}